// extracted by mini-css-extract-plugin
export default {"verifyPayment":"styles_verifyPayment__p5Z1t","heading":"styles_heading__KTT5o","table":"styles_table__2NYKh","desc":"styles_desc__pL6Fv"};